import { atom, action } from 'nanostores'

const totalTiles = 26

const validateMax = val => val <= totalTiles
const validateMin = val => val > 0

export const activeTile = atom(1)
export const hoverTile = atom(1)

export const next = action(activeTile, 'next', store => {
  if (validateMax(store.get() + 1)) {
    store.set(store.get() + 1)
  } else {
    store.set(1)
  }
  return store.get()
})

export const prev = action(activeTile, 'prev', store => {
  if (validateMin(store.get() - 1)) {
    store.set(store.get() - 1)
  } else {
    store.set(totalTiles)
  }
  return store.get()
})
